import { useTranslation } from "react-i18next";
import { FirestoreGenerationStatus } from "reedy-data/models";
import { GenerationStatusBadge } from "~/components/generation-status-badge/generation-status-badge";
import { type BadgeStatus } from "~/components/generation-status-badge/labels";
import { type APlusBadgeStatus } from "~/pages/project-details/hooks/use-amplify-status";

const badgeStatus: Record<
  Exclude<APlusBadgeStatus, "unavailable">,
  BadgeStatus
> = {
  none: "none",
  loading: "loading",
  generating: FirestoreGenerationStatus.GENERATING,
  failed: FirestoreGenerationStatus.ERROR,
  generated: FirestoreGenerationStatus.COMPLETED,
};

export const APlusStatusBadge = ({ status }: { status: APlusBadgeStatus }) => {
  const { t } = useTranslation(["components"]);

  if (status !== "unavailable") {
    return (
      <GenerationStatusBadge
        labelKey="aPlusContent"
        status={badgeStatus[status]}
      />
    );
  }

  const label = t("components:generationStatusBadge.labels.aPlusContent");

  return (
    <GenerationStatusBadge
      labelKey="aPlusContent"
      status="none"
      errorMessage={t("components:generationStatusBadge.tooltips.unavailable", {
        label,
      })}
    />
  );
};
